<div class="h-full w-full">
    <div class="h-5/6">
        <div class="border-2 border-black w-full h-full" [id]="mapId"></div>
    </div>  
    <div class="h-1/6 mt-2 overflow-y-auto">
        <div class="flex flex-wrap gap-4 justify-around items-center h-full">
            @for (marker of markerList; track $index; let i = $index) {
                <div class="flex flex-col">
                    <div (click)="goToMarker(i)" class="flex items-center cursor-pointer">
                        <mat-icon [svgIcon]="getMarkerIcon(i)" class="icon-size-10"></mat-icon>
                    </div>
                </div>
            }
        </div>
    </div>  
</div>